module.exports = __webpack_public_path__ + "static/media/linechart.cca64f85.png";